// Máscaras do formulário de lojista: WhatsApp, CNPJ e Instagram se
// formatam enquanto a pessoa digita ou cola, sem o cursor pular para o
// fim, e o valor que não fecha fica inválido com a mensagem do tema
// (data-invalid). Quem barra o envio é a validação nativa que o
// forms-bridge.js já chama.

// Valor de cada caractere no dígito verificador do CNPJ: o código menos
// 48, que dá o próprio número nos dígitos e 17 a 42 nas letras (regra da
// Receita para o CNPJ alfanumérico, emitido desde julho de 2026).
function digitoCnpj(base) {
  let peso = 2;
  let soma = 0;
  for (let i = base.length - 1; i >= 0; i -= 1) {
    soma += (base.charCodeAt(i) - 48) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

function cnpjValido(bruto) {
  if (!/^[0-9A-Z]{12}\d{2}$/.test(bruto) || /^(\d)\1{13}$/.test(bruto)) return false;
  const primeiro = digitoCnpj(bruto.slice(0, 12));
  const segundo = digitoCnpj(bruto.slice(0, 12) + primeiro);
  return bruto.endsWith(`${primeiro}${segundo}`);
}

const MASCARAS = {
  phone: {
    fica: (c) => /\d/.test(c),
    limite: 11,
    // Colado com o +55 na frente, o código do país sai.
    ajusta: (bruto) => (bruto.length > 11 && bruto.startsWith('55') ? bruto.slice(2) : bruto),
    formata(bruto) {
      if (!bruto) return '';
      if (bruto.length <= 2) return `(${bruto}`;
      const resto = bruto.slice(2);
      const corte = bruto.length > 10 ? 5 : 4;
      const meio = resto.length > corte ? `${resto.slice(0, corte)}-${resto.slice(corte)}` : resto;
      return `(${bruto.slice(0, 2)}) ${meio}`;
    },
    valido: (bruto) => bruto.length === 10 || bruto.length === 11,
  },
  cnpj: {
    fica: (c) => /[0-9A-Za-z]/.test(c),
    limite: 14,
    // Letras em maiúscula, e as duas últimas posições só aceitam número.
    ajusta: (bruto) => {
      const maiusculo = bruto.toUpperCase();
      return maiusculo.slice(0, 12) + maiusculo.slice(12).replace(/\D/g, '');
    },
    formata(bruto) {
      const partes = [bruto.slice(0, 2), bruto.slice(2, 5), bruto.slice(5, 8), bruto.slice(8, 12), bruto.slice(12, 14)];
      const separadores = ['', '.', '.', '/', '-'];
      return partes.reduce((texto, parte, i) => (parte ? texto + separadores[i] + parte : texto), '');
    },
    valido: cnpjValido,
  },
  instagram: {
    fica: (c) => /[A-Za-z0-9._]/.test(c),
    limite: 30,
    // Link colado (instagram.com/sualoja) vira só o usuário.
    limpa: (texto) => texto.replace(/^.*instagram\.com\//i, '').replace(/[/?#].*$/, ''),
    ajusta: (bruto) => bruto.toLowerCase(),
    formata: (bruto) => (bruto ? `@${bruto}` : ''),
  },
};

function bruto(texto, mascara) {
  const limpo = mascara.limpa ? mascara.limpa(texto) : texto;
  return [...limpo].filter(mascara.fica).join('');
}

function aplicar(campo, mascara) {
  const antes = campo.value;
  const cursor = campo.selectionStart ?? antes.length;
  const ateCursor = bruto(antes.slice(0, cursor), mascara).length;

  let valor = bruto(antes, mascara);
  if (mascara.ajusta) valor = mascara.ajusta(valor);
  valor = valor.slice(0, mascara.limite);

  const formatado = mascara.formata(valor);
  if (formatado !== antes) {
    campo.value = formatado;
    // O cursor volta para depois do mesmo número de caracteres úteis.
    if (document.activeElement === campo) {
      let contados = 0;
      let posicao = 0;
      const alvo = Math.min(ateCursor, valor.length);
      while (posicao < formatado.length && contados < alvo) {
        if (mascara.fica(formatado[posicao])) contados += 1;
        posicao += 1;
      }
      campo.setSelectionRange(posicao, posicao);
    }
  }

  const ok = !valor || !mascara.valido || mascara.valido(valor);
  campo.setCustomValidity(ok ? '' : campo.dataset.invalid || ' ');
}

// Avisos por campo, no lugar do balão do navegador (que só aparecia no
// envio, só no primeiro campo e sumia sozinho): o texto fica embaixo do
// campo, com a borda vermelha, e some assim que o valor fica certo.
function textoDoAviso(campo, formulario) {
  const validade = campo.validity;
  if (validade.valid) return '';
  if (validade.customError) return campo.validationMessage;
  if (validade.valueMissing) return campo.tagName === 'SELECT' ? formulario.dataset.msgState : formulario.dataset.msgRequired;
  if (validade.typeMismatch) return formulario.dataset.msgEmail;
  return campo.validationMessage;
}

function avisar(campo, formulario) {
  const caixa = campo.closest('.lojista-form__field');
  if (!caixa) return;
  let aviso = caixa.querySelector('.lojista-form__error');
  if (!aviso) {
    aviso = document.createElement('span');
    aviso.className = 'lojista-form__error';
    aviso.id = `lojista-${campo.name.replace(/\W+/g, '-')}erro`;
    // Fora do nome do campo (ele mora dentro do <label>), mas lido como
    // descrição pelo aria-describedby.
    aviso.setAttribute('aria-hidden', 'true');
    caixa.append(aviso);
    campo.setAttribute('aria-describedby', aviso.id);
  }
  const texto = textoDoAviso(campo, formulario);
  aviso.textContent = texto;
  aviso.hidden = !texto;
  if (texto) campo.setAttribute('aria-invalid', 'true');
  else campo.removeAttribute('aria-invalid');
}

function ligar(formulario) {
  if (formulario.dataset.mascaras) return;
  formulario.dataset.mascaras = '1';

  // O forms-bridge.js chama checkValidity no envio, e cada campo inválido
  // dispara 'invalid': o aviso aparece em todos, sem o balão, e a página
  // leva ao primeiro.
  let primeiro = null;
  formulario.addEventListener('invalid', (evento) => {
    evento.preventDefault();
    avisar(evento.target, formulario);
    if (primeiro) return;
    primeiro = evento.target;
    setTimeout(() => {
      primeiro.scrollIntoView({ block: 'center' });
      primeiro.focus({ preventScroll: true });
      primeiro = null;
    });
  }, true);

  // Ao sair do campo com algo escrito, ele já diz se está certo; vazio, só
  // no envio, para não acusar quem ainda está passando pelos campos.
  formulario.addEventListener('focusout', (evento) => {
    const campo = evento.target;
    if (!campo.name || !campo.matches('input, select, textarea')) return;
    if (campo.value || campo.hasAttribute('aria-invalid')) avisar(campo, formulario);
  });

  // Com aviso na tela, ele acompanha a digitação e some quando fica certo.
  const reavaliar = (evento) => {
    if (evento.target.hasAttribute('aria-invalid')) avisar(evento.target, formulario);
  };
  formulario.addEventListener('input', reavaliar);
  formulario.addEventListener('change', reavaliar);

  formulario.querySelectorAll('[data-mask]').forEach((campo) => {
    const mascara = MASCARAS[campo.dataset.mask];
    if (!mascara) return;
    campo.addEventListener('input', () => aplicar(campo, mascara));
    // Preenchimento automático do navegador chega antes do script.
    if (campo.value) aplicar(campo, mascara);
  });

  // Depois do envio o forms-bridge.js limpa o formulário: campo vazio não
  // carrega o erro do valor anterior.
  formulario.addEventListener('reset', () => {
    setTimeout(() => {
      formulario.querySelectorAll('[data-mask]').forEach((campo) => campo.setCustomValidity(''));
      formulario.querySelectorAll('[aria-invalid]').forEach((campo) => campo.removeAttribute('aria-invalid'));
      formulario.querySelectorAll('.lojista-form__error').forEach((aviso) => { aviso.hidden = true; });
    });
  });
}

document.querySelectorAll('[data-lojista-form]').forEach(ligar);
document.addEventListener('shopify:section:load', (evento) => {
  evento.target.querySelectorAll('[data-lojista-form]').forEach(ligar);
});
